module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "candidate"
  }, _vm._l((_vm.list), function(item) {
    return _c('x-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.accessable !== false),
        expression: "item.accessable !== false"
      }],
      key: item.id,
      attrs: {
        "data-value": item.value,
        "type": item.value === _vm.value ? 'primary' : 'default',
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57e06cc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Candidate.vue
// module id = 670
// module chunks = 1